import crp from "app/utils/crp";
import decrypt from "app/utils/decrypt";
import { ERapidApiAxios, ERapidAuthAxios } from "../utils/Axios";

const host = process.env.REACT_APP_API_ERAPIDS;
const hostAuth = process.env.REACT_APP_API_IDM;
const userNameIDM = process.env.REACT_APP_USER_NAME;
const passIDM = process.env.REACT_APP_PASSWORD;
const hostIDMEmployee = process.env.REACT_APP_API_IDMEMPLOYEE;

function NOW() {

    var date = new Date();
    var aaaa = date.getFullYear();
    var gg = date.getDate();
    var mm = (date.getMonth() + 1);

    if (gg < 10)
        gg = "0" + gg;

    if (mm < 10)
        mm = "0" + mm;

    var cur_day = aaaa + "-" + mm + "-" + gg;

    var hours = date.getHours()
    var minutes = date.getMinutes()
    var seconds = date.getSeconds();

    if (hours < 10)
        hours = "0" + hours;

    if (minutes < 10)
        minutes = "0" + minutes;

    if (seconds < 10)
        seconds = "0" + seconds;

    return cur_day + " " + hours + ":" + minutes + ":" + seconds;

}

export default {
    authUser(params) {
        const url = `${hostAuth}/api/Authenticate`
        const method = 'POST';
        let data = {
            Username: params.username,
            Password: params.password,
            TypeCredential: params.TypeCredential,
            AppName: 'IDM',
            AppNameSecurity: "Erapids",
            Grant_type: "password",
            Email: params.email,
            tokenGoogle: params.tokenGoogle,
            Ficha: params.recordNumber,
            FechaIngreso: params.admissionDate,
            IsEncrypted: true
        }

        if (params.TypeCredential !== 5)
            delete data.FechaIngreso;


        return this.makeRequest({ method, url, data });
    },

    generateToken() {
        const url = `${hostAuth}/api/Authenticate`
        const method = 'POST';
        let data = {
            userName: decrypt(userNameIDM),
            password: decrypt(passIDM),
            typeCredential: 3,
            appName: 'IDMEmployee',
            appNameSecurity: 'IDMEmployee'
        }
        return this.makeRequest({ method, url, data });
    },
    getExternalEmployee(token) {
        const url = `${hostIDMEmployee}/api/Employees/externalEmployee`
        const method = 'GET';
        const headers = {
            Authorization: `Bearer ${token}`,
        }
        return this.makeRequest({ method, url, headers });
    },

    getTokenErapids(params) {
        const url = `${hostAuth}/api/Authenticate`
        const method = 'POST';
        let data = {
            Username: params.username,
            Password: params.password,
            TypeCredential: params.TypeCredential,
            AppName: 'Erapids',
            AppNameSecurity: "Erapids",
            Grant_type: "password",
            Email: params.email,
            tokenGoogle: params.tokenGoogle,
            Ficha: params.recordNumber,
            FechaIngreso: params.admissionDate,
            IsEncrypted: true
        }

        if (params.TypeCredential !== 5)
            delete data.FechaIngreso;

        return this.makeRequest({ method, url, data });
    },

    getRefreshTokenErapids(refresh) {
        const url = `${hostAuth}/api/Authenticate/refresh`
        const method = 'POST';
        const data = {

            RefreshToken: refresh
        }
        return this.makeRequest({ method, url, data });
    },


    //Login
    authUserErapids(params) {
        const url = `${hostAuth}/api/Security/Login`
        const method = 'POST';
        const headers = {
            Authorization: `Bearer ${params.token}`
        };
        let data = {
            TypeCredential: params.TypeCredential,
            Email: params.email,
            Ficha: params.recordNumber,
            UserName: params.username,
            Password: params.password,
            Grant_type: 'password',
            AppName: 'Erapids',
            AppNameSecurity: "Erapids",
            IsEncrypted: true
        }
        if (params.TypeCredential === 5) {
            data = {
                ...data,
                FechaIngreso: params.admissionDate,
            }
        }
        return this.makeAuthorizedRequest({ method, url, data, headers });
    },


    getScreenByUser(params, token) {
        const queries = this.makeQueryParams('', params);
        const method = 'GET';
        const headers = {
            Authorization: `Bearer ${token}`
        };
        const url = `${hostAuth}/api/Screens/GetScreenRetrieveByUserRol?${queries}`
        return this.makeAuthorizedRequest({ method, url, headers });
    },

    //Login with Active Directory
    authUserErapids01(params) {
        const url = `${hostAuth}/api/Security/Login`
        const method = 'POST';
        const headers = {
            Authorization: `Bearer ${params.token}`
        };
        const data = {
            TypeCredential: 1,
            AppName: 'Erapids',
        }
        return this.makeAuthorizedRequest({ method, url, data, headers });
    },

    getTableData() {
        const url = `${host}api/Courses/`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getCourses(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Courses?${queries}`;
        return this.makeAuthorizedRequest({ url, method });
    },

    getCoursesExport(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Courses/ExportToExcel?${queries}`
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },

    getCoursesFilter(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/Courses/Filters?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getCourseAttachment(param) {
        const url = `${host}api/Courses/${param}/Attachments`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getCoursesTestsAvailable(idCourse, idTraining) {
        const url = `${host}api/Courses/${idCourse}/${idTraining}/TestsAvailable`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getCoursesTests(param) {
        const url = `${host}api/Courses/${param}/Tests`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getCoursesWorkCyclesAvailable(param) {
        const url = `${host}api/Courses/${param}/TestWorkCycleAvailable`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getCoursesWorkCycles(param) {
        const url = `${host}api/Courses/${param}/TestWorkCycles`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    setRestoreCourse(param) {
        const url = `${host}api/Courses/restore/${param}`;
        const method = 'PUT';
        return this.makeAuthorizedRequest({ method, url });
    },

    setActiveVideo(param) {
        const url = `${host}api/Courses/reactivevideo/${param}`;
        const method = 'PUT';
        return this.makeAuthorizedRequest({ method, url });
    },

    setCourses(params, meth) {
        const url = `${host}api/Courses/`;
        const method = meth;
        const data = { ...params };
        return this.makeAuthorizedRequest({ url, method, data });
    },
    setVersionCourse(params, meth) {
        const url = `${host}api/Courses/CourseVersion`;
        const method = meth;
        const data = { ...params };
        return this.makeAuthorizedRequest({ url, method, data });
    },
    deleteCourse(idCourse) {
        const method = 'DELETE';
        const url = `${host}api/Courses/${idCourse}`;
        return this.makeAuthorizedRequest({ method, url });
    },
    suspendCourse(idCourse) {
        const method = 'DELETE';
        const url = `${host}api/Courses/suspend/${idCourse}`;
        return this.makeAuthorizedRequest({ method, url });
    },
    getCourseMultimedia(idCourse) {
        const url = `${host}api/Courses/${idCourse}/Multimedia/`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })
    },

    getCourseCategoriesAvailablebyId(param) {
        const queries = this.makeQueryParams('', param);
        const url = `${host}api/Courses/CategoriesAvailable?${queries}`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getCourseCategoriesbyId(param) {
        const queries = this.makeQueryParams('', param);
        const url = `${host}api/Courses/Categories?${queries}`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getCourseClientProceduresAvailablebyId(param) {
        const url = `${host}api/Courses/${param}/ClientProceduresAvailable`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getCourseClientProceduresbyId(param) {
        const url = `${host}api/Courses/${param}/ClientProcedures`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getCourseHomologousProcedureAvailablebyId(param) {
        const url = `${host}api/Courses/${param}/HomologousProceduresAvailable`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getCourseHomologousProcedurebyId(param) {
        const url = `${host}api/Courses/${param}/HomologousProcedures`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getSubdirections() {
        const url = `${host}api/Subdirections`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getContracts() {
        const url = `${host}api/Contracts`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getWorks() {
        const url = `${host}api/Works`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    removeQuestions(idQuestion) {
        const url = `${host}api/Questions/${idQuestion}`;
        const method = 'DELETE';
        return this.makeAuthorizedRequest({ url, method });
    },

    setTest(params, method) {
        const url = `${host}api/Tests`;
        const data = params;
        return this.makeAuthorizedRequest({ url, method, data });
    },
    deleteTest(id) {
        const url = `${host}api/Tests/${id}`;
        const method = 'DELETE';
        return this.makeAuthorizedRequest({ url, method });
    },

    getTests(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Tests?${queries}`
        return this.makeAuthorizedRequest({ url, method, data });
    },

    setTestQuestionAnswer(params = {}, meth) {
        const url = `${host}api/Tests/${params.idTest}/QuestionAnswer`;
        const method = meth;
        const data = params.questions;
        return this.makeAuthorizedRequest({ url, method, data });
    },

    getTestFilter(SubDirection, EmployeeId) {
        const url = `${host}api/Tests/Filters/${SubDirection}/${EmployeeId}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getTestQuestionsbyId(idTest) {
        const url = `${host}api/Tests/${idTest}/Questions`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getExportToExcel(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Tests/ExportToExcel?${queries}`
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },
    getTestTemplate(data) {
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Tests/DownloadLayoutQuestionAnswerForTest?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },
    postTestTemplate(data, queries) {
        const url = `${host}api/Tests/${queries}/ImportQuestionAnswer`
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, data });
    },
    putViewAnswers(data, id) {
        const url = `${host}api/Courses/showanswer/${id}?showAnswer=${data}`
        const method = 'PUT';
        return this.makeAuthorizedRequest({ url, method });
    },
    getTestWorkCycleTemplate(data) {
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/TestWorkCycles/DownloadLayoutQuestionAnswerForTest?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },
    postTestWorkCyclesTemplate(data, queries) {
        const url = `${host}api/TestWorkCycles/${queries}/ImportQuestionAnswer`
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, data });
    },
    getWorkCycleExportToExcel(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/TestWorkCycles/ExportToExcel?${queries}`
        return this.makeAuthorizedRequest({
            url, method, responseType: 'arraybuffer'
        });
    },

    getWorkCycles(data = {}) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/TestWorkCycles?${queries}`
        return this.makeAuthorizedRequest({ url, method, data });
    },

    getWorkCyclesFilters(data = {}) {
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/TestWorkCycles/Filters?${queries}`;
        const method = 'GET';
        //const data = {};
        return this.makeAuthorizedRequest({ url, method, data })
    },

    setWorkCycles(params = {}, meth) {
        const url = `${host}api/TestWorkCycles`;
        const method = meth;
        const data = {
            ...params,
            isWorkCycle: true
        }
        return this.makeAuthorizedRequest({ url, method, data });
    },

    setWorkCycleQuestionAnswer(params = {}, meth) {
        const url = `${host}api/TestWorkCycles/${params.idTest}/QuestionAnswer`;
        const method = meth;
        const data = params.questions;
        return this.makeAuthorizedRequest({ url, method, data });
    },

    deleteWorkCycles(idTest) {
        const url = `${host}api/TestWorkCycles/${idTest}`;
        const method = 'DELETE';
        return this.makeAuthorizedRequest({ url, method });
    },

    setAttachment(params) {
        const url = `${host}api/Attachments/`;
        const method = 'POST';
        const data = {
            idCourse: params.idCourse,
            fileName: params.fileName,
            fileExtension: params.fileExtension,
            fileInformation: params.fileInformation,
        };
        return this.makeAuthorizedRequest({ url, method, data });
    },


    getSas() {
        const url = `${host}api/Authenticate/AzureStorage`
        const method = 'GET'
        return this.makeAuthorizedRequest({ url, method })
    },

    setAccessComponent(idCourse) {
        const url = `${host}api/Multimedia/AccessComponents/${idCourse}`
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method })
    },

    setMigrateMediaServices(params = {}, filename) {
        const url = `${host}api/Multimedia/MigrateMediaServices`;
        const method = 'POST';
        const data = {
            ...params
        }
        return this.makeAuthorizedRequest({ url, method, data });
    },

    setDiffusion(data, meth) {
        const url = `${host}api/Diffusion`;
        const method = meth;
        return this.makeAuthorizedRequest({ url, method, data });
    },

    deleteDiffusion(idDiffusion) {
        const url = `${host}api/Diffusion/${idDiffusion}`;
        const method = 'DELETE';
        return this.makeAuthorizedRequest({ url, method });
    },
    getCommunicationProgramDiffusionbyId(idCommunicationProgram) {
        const url = `${host}api/CommunicationPrograms/${idCommunicationProgram}/Diffusion`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getDiffusion(param) {
        const url = `${host}api/CommunicationPrograms/${param}/Diffusion`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getCommunicationPrograms(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/CommunicationPrograms?${queries}`
        return this.makeAuthorizedRequest({ url, method, data });
    },

    getCommunicationProgramsExport(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/CommunicationPrograms/ExportToExcel?${queries}`
        return this.makeAuthorizedRequest({
            url, method, responseType: 'arraybuffer'
        });
    },

    getCommunicationProgramsSummaryExport(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        //const url = `${host}api/CommunicationPrograms/Summary/Export?${queries}` //Old request
        const url = `${host}api/Communications/ComplianceAdvance/ExportAllLevels?${queries}`
        return this.makeAuthorizedRequest({
            url, method, responseType: 'arraybuffer'
        });
    },

    getCommunicationProgramsSummaryFilters(data = {}) {
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/CommunicationPrograms/Summary/Filters?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, data });
    },

    getCommunicationProgramsFilter(data = {}) {
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/CommunicationPrograms/Filters?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, data });
    },

    setCommunicationPrograms(params = {}, meth) {
        const url = `${host}api/CommunicationPrograms`;
        const method = meth;
        const data = {
            ...params
        }
        return this.makeAuthorizedRequest({ url, method, data });
    },

    getCommunicationProgramCoursebyId(idCommunicationProgram) {
        const url = `${host}api/CommunicationPrograms/${idCommunicationProgram}/Courses`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getCommunicationProgramCourseAvailablebyId(param) {
        const url = `${host}api/CommunicationPrograms/${param}/CoursesAvailable`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    deleteCommunicationProgram(param) {
        const url = `${host}api/CommunicationPrograms/${param}`;
        const method = 'DELETE';
        return this.makeAuthorizedRequest({ method, url });
    },

    suspendCommunicationProgram(param) {
        const url = `${host}api/CommunicationPrograms/Suspend/${param}`;
        const method = 'PUT';
        return this.makeAuthorizedRequest({ method, url });
    },

    getCoursesAvailable(param) {
        const url = `${host}api/CommunicationPrograms/${param}/CoursesAvailable`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getCategoriesAvailable(param) {
        const url = `${host}api/CommunicationPrograms/${param}/CategoriesAvailable`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getCommunicationProgramsSummary(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/CommunicationPrograms/Summary?${queries}`
        return this.makeAuthorizedRequest({ url, method, data });
    },

    getCommunicationProgramsGraphics(data) {
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/CommunicationPrograms/Graphics?${queries}`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getCommunicationProgramsDetails(data, idCommunicationProgram) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/CommunicationPrograms/${idCommunicationProgram}/Details?${queries}`
        return this.makeAuthorizedRequest({ url, method, data });
    },
    exportCommunicationProgramsById(data, idCommunicationProgram) {
        const method = 'GET';
        const nData = { ...data, idCommunicationProgram }
        const queries = this.makeQueryParams('', nData);
        //const url = `${host}api/CommunicationPrograms/${idCommunicationProgram}/ExportCommunications?${queries}` //Old request
        const url = `${host}api/Communications/ComplianceAdvance/ExportAllLevels?${queries}`
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },

    getCategories(param) {
        const url = `${host}api/Categories`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getSpecialty(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Specialty?${queries}`
        return this.makeAuthorizedRequest({ url, method });
    },

    getSpecialtyExport(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Specialty/ExportToExcel?${queries}`
        return this.makeAuthorizedRequest({
            url, method, responseType: 'arraybuffer'
        });
    },


    getSpecialtyFilter(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/Specialty/Filters?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    setSpecialty(data, meth) {
        const url = `${host}api/Specialty/`
        const method = meth
        return this.makeAuthorizedRequest({ url, method, data });
    },

    deleteSpecialty(param) {
        const url = `${host}api/Specialty/${param}`;
        const method = 'DELETE';
        return this.makeAuthorizedRequest({ method, url });
    },

    getClient(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Clients?${queries}`
        return this.makeAuthorizedRequest({ url, method });
    },

    getClientExport(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Clients/ExportToExcel?${queries}`
        return this.makeAuthorizedRequest({
            url, method, responseType: 'arraybuffer'
        });
    },

    getClientFilter() {
        const url = `${host}api/Clients/Filters`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    setClient(data, meth) {
        const url = `${host}api/Clients/`
        const method = meth
        return this.makeAuthorizedRequest({ url, method, data });
    },

    deleteClient(param) {
        const url = `${host}api/Clients/${param}`;
        const method = 'DELETE';
        return this.makeAuthorizedRequest({ method, url });
    },

    // ---
    getClientProcedure(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Procedures?${queries}`
        return this.makeAuthorizedRequest({ url, method });
    },

    getClientProcedureExport(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Procedures/ExportClientProcedureToExcel?${queries}`
        return this.makeAuthorizedRequest({
            url, method, responseType: 'arraybuffer'
        });
    },

    getHomologousProcedureExport(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Procedures/ExportHomologousProcedureToExcel?${queries}`
        return this.makeAuthorizedRequest({
            url, method, responseType: 'arraybuffer'
        });
    },

    getClientProcedureFilter(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Procedures/Filters?${queries}`
        return this.makeAuthorizedRequest({ url, method });
    },

    setProcedure(data, meth) {
        const url = `${host}api/Procedures/`
        const method = meth
        return this.makeAuthorizedRequest({ url, method, data });
    },

    deleteProcedure(param) {
        const url = `${host}api/Procedures/${param}`;
        const method = 'DELETE';
        return this.makeAuthorizedRequest({ method, url });
    },
    // --

    getPendingCommunications(IdEmployee, data) {
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Employees/${IdEmployee}/CommunicationsPending?${queries}`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });

    },

    getFinishedCommunications(IdEmployee, data) {
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Employees/${IdEmployee}/CommunicationsFinished?${queries}`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getCommunicationProgramByEmployeeId(IdEmployee) {
        const url = `${host}api/Employees/${IdEmployee}/CommunicationProgram`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getCommunicationProgramSummary(params = {}) {
        const url = `${host}api/Employees/${params.idEmployee}/CommunicationProgram/${params.idCommunicationProgram}/Summary`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });

    },

    getSpecialtySummary(params = {}) {
        const url = `${host}api/Employees/${params.idEmployee}/Communications/${params.idCommunicationProgram}/SpecialtySummary`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });

    },
    getSystemSummary(params = {}) {
        const url = `${host}api/Employees/${params.idEmployee}/Communications/${params.idCommunicationProgram}/SystemSummary`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });

    },

    getCommunicationsDispatch(id, data) {
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Employees/${id}/CommunicationsDispatch?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, data });
    },

    getCommunicationsDispatchFilters(idEmployee) {
        const url = `${host}api/Employees/${idEmployee}/CommunicationsFilters`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    ExportCommunicationDispatch(idEmployee, data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Employees/${idEmployee}/CommunicationsDispatch/Export?${queries}`
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },

    setEmployeeSupervisor(data, meth) {
        const url = `${host}api/Employees/Supervisor/`
        const method = meth
        return this.makeAuthorizedRequest({ url, method, data });
    },

    getEmployeeSupervisor(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Employees/GetSupervisor?${queries}`
        return this.makeAuthorizedRequest({ url, method });
    },

    exportEmployeeSupervisor(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Employees/GetSupervisor/ExportToExcel?${queries}`
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },

    getEmployeeSupervisorFilter(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Employees/GetSupervisorFilters?${queries}`
        return this.makeAuthorizedRequest({ url, method });
    },

    getEmployeeSupervisorAvailable(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Employees/GetAvailableSupervisor?${queries}`
        return this.makeAuthorizedRequest({ url, method });
    },

    setEmployeeBoss(data, meth) {
        const url = `${host}api/Employees/Boss/`
        const method = meth
        return this.makeAuthorizedRequest({ url, method, data });
    },

    getEmployeeBoss(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Employees/GetBoss?${queries}`
        return this.makeAuthorizedRequest({ url, method });
    },

    exportEmployeeBoos(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Employees/GetBoss/ExportToExcel?${queries}`
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },

    getEmployeeBossFilter(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Employees/GetBossFilters?${queries}`
        return this.makeAuthorizedRequest({ url, method });
    },

    getEmployeeBossAvailable(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Employees/GetAvailableBoss?${queries}`
        return this.makeAuthorizedRequest({ url, method });
    },


    getEmployeeById(idEmployee) {
        const url = `${host}api/Employees/${idEmployee}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    /* Empleados para asignacion */
    getEmployeesByCategory(data) {
        const queries = this.makeQueryParams('', data);
        //const url = `${host}api/Employees/GetEmployeePuestoComunicationProgram?${queries}`;
        const url = `${host}api/Employees/GetEmployeeCategory`;
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, data });
    },
    /* Empleados para asignacion */
    getEmployeesByIdEmployee(data) {
        const url = `${host}api/Employees/GetEmployeeByFile`;
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, data });
    },
    /* Empleados ya asignados por ficha */
    getAssignedEmployeesByIdEmployee(data) {
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Employees/GetEmployeeFichaComunicationProgramAsigned?${queries}`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, data });
    },

    getFronts() {
        const url = `${host}api/Fronts`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getCommunicationQuiz(IdCommunication) {
        const url = `${host}api/Communications/${IdCommunication}/Quiz`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });

    },
    putQualification(idCommunication, data) {
        const url = `${host}api/Communications/${idCommunication}/Qualification`;
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, data });

    },

    getResponsableQuiz(idCommunication) {
        const url = `${host}api/Communications/${idCommunication}/ResponsibleQuiz`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    setResponsibleQualification(idEmployee, data) {
        const url = `${host}api/Communications/ResponsibleQualification/${idEmployee}`;
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, data });

    },

    getCommunicationComplianceAdvance(data) {
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Communications/ComplianceAdvance?${queries}`
        const method = 'GET'
        return this.makeAuthorizedRequest({ url, method, data });
    },
    exportComplianceAdvance(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        //const url = `${host}api/Communications/ComplianceAdvance/Export?${queries}` //Old request
        const url = `${host}api/Communications/ComplianceAdvance/ExportAllLevels?${queries}`
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },

    programingSendEmail(idDiffusionCourse, employeeId) {
        const method = 'POST';
        const url = `${host}api/Communications/ProgramingSendEmail/${idDiffusionCourse}/${employeeId}`
        return this.makeAuthorizedRequest({ url, method });
    },
    setQuizVideoSeconds(data) {
        const url = `${host}api/Communications/Seconds`
        const method = 'PUT';
        return this.makeAuthorizedRequest({ url, method, data });
    },

    getCommunicationSummary(id, data) {
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Employees/${id}/CommunicationSummary?${queries}`
        const method = 'GET'
        return this.makeAuthorizedRequest({ url, method, data });
    },

    getBookmarks(data) {
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Bookmarks?${queries}`
        const method = 'GET'
        return this.makeAuthorizedRequest({ url, method, data });
    },

    setBookmarks(data) {
        const url = `${host}api/Bookmarks`
        const method = 'POST'
        return this.makeAuthorizedRequest({ url, method, data });
    },

    getBookMarkFilter(params) {
        const url = `${host}api/Bookmarks/Filters/${params.idSubdirection}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    deleteBookmark(idBookMark) {
        const url = `${host}api/Bookmarks/${idBookMark}`
        const method = 'DELETE';
        return this.makeAuthorizedRequest({ url, method });

    },

    exportBookmarks(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/BookMarks/ExportToExcel?${queries}`
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },


    getBookmarkPreview(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Bookmarks/GetBookMarkPreview?${queries}`
        return this.makeAuthorizedRequest({ url, method });
    },

    getTechnicalRepresentative() {
        const url = `${host}api/Responsible/GetTechnicalRepresentative`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getBookmarkCourseFilter(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Bookmarks/FilterCourse?${queries}`
        return this.makeAuthorizedRequest({ url, method });
    },
    //---
    getResponsible(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Responsibles?${queries}`
        return this.makeAuthorizedRequest({ url, method });
    },

    getResponsibleExport(idRol, data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Responsibles/${idRol}/ExportToExcel?${queries}`
        return this.makeAuthorizedRequest({
            url, method, responseType: 'arraybuffer'
        });
    },


    getResponsibleFilter(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Responsibles/Filters?${queries}`
        return this.makeAuthorizedRequest({ url, method });
    },

    setResponsible(data, meth) {
        const url = `${host}api/Responsibles/`
        const method = meth
        return this.makeAuthorizedRequest({ url, method, data });
    },

    deleteResponsible(param) {
        const url = `${host}api/Responsibles/${param}`;
        const method = 'DELETE';
        return this.makeAuthorizedRequest({ method, url });
    },
    getClientReports(data, IdCommunicationProgram) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Reports/${IdCommunicationProgram}/ReportClient?${queries}`
        return this.makeAuthorizedRequest({ url, method });
    },

    getProcess(data, idCommunicationProgram) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Process/${idCommunicationProgram}/Courses?${queries}`
        return this.makeAuthorizedRequest({ url, method });
    },

    getProcessFilter(params) {
        const url = `${host}api/Process/Filters/${params.idSubdirection}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    setProcessbyId(data, id) {
        const url = `${host}api/Process/${id}/Courses`
        const method = 'PUT';
        return this.makeAuthorizedRequest({ url, method, data });
    },

    deleteProcessById(id, front) {
        const url = `${host}api/Process/${id}/Front/${front}/Courses`
        const method = 'DELETE';
        return this.makeAuthorizedRequest({ url, method });
    },

    getManagementReport(data, id) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/GerencyReports/${id}/GenerateReport?${queries}`
        return this.makeAuthorizedRequest({ url, method });
    },

    getManagementReportFilter(params) {
        const url = `${host}api/GerencyReports/Filters/${params.idSubdirection}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    acceptDisclaimer(data) {
        const url = `${host}api/Disclaimer/AcceptDisclaimer`
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, data });
    },
    getDisclaimerActive() {
        const url = `${host}api/Disclaimer/Active`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    endCommunication(idCommunication) {
        const url = `${host}api/Communications/${idCommunication}/EndCommunication`;
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method });

    },
    //--
    async getNewToken(refresh_token) {
        const url = '/oauth/token...';
        const method = 'POST';
        const data = {
            grant_type: 'refresh_token',
            refresh_token
        };
        return this.makeRequest({ method, url, data });
    },

    async makeRequest(requestData = {}) {

        let res = await ERapidAuthAxios(requestData);
        return res.data;
    },

    async makeAuthorizedRequest(requestData = {}) {

        let res = await ERapidApiAxios(requestData);

        return res.data;
    },

    makeQueryParams(obj = '', params) {
        let queries = '';
        for (var key in params) {
            if (Array.isArray(params[key])) {
                // eslint-disable-next-line no-loop-func
                params[key].map(item => queries += `${obj}${key}=${item}&`);
            } else queries += `${obj}${key}=${params[key]}&`;
        }
        return queries;
    },

    getSiteId() {
        const url = `${host}api/SiteConfig`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getNamesTraining() {
        const url = `${host}api/Training/names`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getSubdirectionsTraining() {
        const url = `${host}api/Training/subdirection`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    fetchTraining(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/Training/paginate?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    exportTraining(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/Training/ExportToExcel?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },
    insUpdTraining(data) {
        const url = `${host}api/Training`
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, data });
    },
    deleteTraining(idTraining) {
        const method = 'DELETE';
        const url = `${host}api/Training/${idTraining}`;
        return this.makeAuthorizedRequest({ method, url });
    },
    getEmployee() {
        const url = `${host}api/Training/EmployeeAdmin`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getEmployeeId(id) {
        const url = `${host}api/Training/EmployeeIdTraining/${id}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    insUpdEmployeeTraining(data) {
        const url = `${host}api/Training/assignadministrator`
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, data });
    },
    getSystemNames(subdirection) {
        const url = `${host}api/System/names/${subdirection}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getKeyUserNames(subdirection) {
        const url = `${host}api/System/keyuser/${subdirection}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getAllKeyUserNames() {
        const url = `${host}api/System/keyuser`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    getEditKeyUserNames(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/System/keyuser/idSystem?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },


    getFunctionalNames(subdirection) {
        const url = `${host}api/System/functional/${subdirection}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    fetchSystems(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/System/paginate?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },

    exportSystems(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/System/ExportToExcel?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },

    insUpdSystem(data) {
        const url = `${host}api/System`
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, data });
    },

    deleteSystem(idSystem) {
        const method = 'DELETE';
        const url = `${host}api/System/${idSystem}`;
        return this.makeAuthorizedRequest({ method, url });
    },

    checkSystemTrainingPermission(employeeId) {
        const url = `${host}api/Training/SystemTrainingPermissions/${employeeId}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getTrainingEmployee(employeeId) {
        const url = `${host}api/Training/select/${employeeId}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getSystemSpecialty(idSubdirection) {
        const url = `${host}api/System/systemSpecialty/${idSubdirection}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    //UserSearch
    getInternalEmployeesNames(listNames) {
        const queries = this.makeQueryParams('', listNames);
        const url = `${host}api/UserSearch/namesInternal?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, listNames });
    },
    getInternalEmployeesSubdirection() {
        const url = `${host}api/UserSearch/subdirection`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getInternalEmployeesId(listFiles) {
        const queries = this.makeQueryParams('', listFiles);
        const url = `${host}api/UserSearch/fichas?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, listFiles });
    },
    getInternalEmployeesCompany() {
        const url = `${host}api/UserSearch/company`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getInternalEmployeesCategory(listJobs) {
        const queries = this.makeQueryParams('', listJobs);
        const url = `${host}api/UserSearch/jobs?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, listJobs });
    },
    getInternalEmployeesContract() {
        const url = `${host}api/UserSearch/contract`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getInternalEmployeesOt() {
        const url = `${host}api/UserSearch/OT`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getInternalEmployeesEmail(listEmails) {
        const queries = this.makeQueryParams('', listEmails);
        const url = `${host}api/UserSearch/emailInternal?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, listEmails });
    },
    getInternalEmployeesCeco() {
        const url = `${host}api/UserSearch/internalCeco`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getInternalEmployeesEpep() {
        const url = `${host}api/UserSearch/internalEpep`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    fetchInternalEmployees(data) {
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/UserSearch/paginateInternal?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, data });
    },
    exportUserSearch(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/UserSearch/ExportToExcelInternal?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },
    exportUserBookmark(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/UserSearch/BookmarkByEmplooye?${queries}`;
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },
    exportUserKardex(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/UserSearch/Kardex/Bookmark?${queries}`;
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },
    //External
    getExternalEmployeesNames(listNames) {
        const queries = this.makeQueryParams('', listNames);
        const url = `${host}api/UserSearch/namesExternal?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, listNames });
    },
    getExternalEmployeesEmail(listEmails) {
        const queries = this.makeQueryParams('', listEmails);
        const url = `${host}api/UserSearch/emailExternal?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, listEmails });
    },
    fetchExternalEmployees(data) {
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/UserSearch/paginateExternal?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, data });
    },
    exportUserSearchExternal(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/UserSearch/ExportToExcelExternal?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },
    fetchKardex(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/UserSearch/kardex?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, params });
    },
    exportKardex(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/UserSearch/ExportToExcelKardex?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },
    getInternalPercnota() {
        //const queries = this.makeQueryParams('', listEmails);
        const url = `${host}api/UserSearch/pernocta`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getInternalComunicationProgram() {
        //const queries = this.makeQueryParams('', listEmails);
        const url = `${host}api/UserSearch/comunicationProgram`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getInternalCourse() {
        //const queries = this.makeQueryParams('', listEmails);
        const url = `${host}api/UserSearch/course`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    //API HistoryCampaign
    getTrainingHC(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/HistoryCampaign/Training?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getSpecialtyOrSystemHC(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/HistoryCampaign/SpecialtyOrSystem?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getCommunicationProgramHC(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/HistoryCampaign/CommunicationProgram?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getProcedureMaterialHC(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/HistoryCampaign/ProcedureMaterial?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    fetchHistoryCampaign(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/HistoryCampaign/paginate?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    exportHistoryCampaign(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/HistoryCampaign/ExportToExcel?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },

    getWorksByidContract(idContract) {
        const url = `${host}api/Works?IdContract=${idContract}`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getComplianceMatrixbyPositionReport(payload) {

        const url = `${host}api/Reports/GenerateClientReportMatrix`;
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, responseType: "blob", data: payload });
    },
    //DailyCompliance
    fetchDailyCompliance(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/DailyCompliance/paginate?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, params });
    },
    exportCompliance(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/DailyCompliance/ExportToExcel?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },

    //Report Compliance Communication Program
    getReportCommunicationProgramGrid(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/ReportCommunicationProgram/ReportCommunicationProgramGrid?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getFilterReportCommunicationProgram(params) {
        const url = `${host}api/ReportCommunicationProgram/Filters/${params.idSubdirection}/${params.employeeId}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getExportReportCommunicationProgram(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/ReportCommunicationProgram/ExportToExcel?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },
    getMediaFilters(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/CotPlayHub/Filters?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })
    },
    setVideoSeconds(data) {
        //const queries = this.makeQueryParams('', params);
        const url = `${host}api/CotPlayHub/SaveSecondsMediaHub`
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, data })
    },
    getMediaCourses(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/CotPlayHub/HubMediaVideo?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })
    },
    getMediaCoursesMostViewed(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/CotPlayHub/HubMediaVideoMostViewed?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })
    },
    trainingNamesMediaVideo() {
        const url = `${host}api/Training/TrainingNamesMediaVideo`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })
    },
    specialtyMediaVideo(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/CotPlayHub/SpecialtyMediaVideo?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })
    },
    finishedMediaHub(data) {
        const url = `${host}api/CotPlayHub/finishedMediaHub`
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, data })
    },
    getCommunicationProgramsForMatriz(idEmployee) {
        const url = `${host}api/Reports/GetCommunicationPrograms?IdEmployee=${idEmployee}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getContractsForMatriz() {
        const url = `${host}api/Reports/GetContractMatriz`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    getWorksByidContractForMatriz(idContract) {

        const url = `${host}api/Reports/GetWorkMatriz?IdContract=${idContract}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    LoadReviewsbyIdCourse(idCourse) {
        const url = `${host}api/CotPlayHub/LoadReviews?IdCourse=${idCourse}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    GetProcessMatrix(idEmployee) {
        const url = `${host}api/Reports/GetProcessMatrix?IdEmployee=${idEmployee}`;
        const method = "GET";
        return this.makeAuthorizedRequest({ url, method });
    },
    //OnSiteEvaluations
    getEvaluationFacetoFace(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/EvaluationFaceToFace?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })
    },
    getExportEvaluationFacetoFace(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/EvaluationFaceToFace/ExportToExcel?${queries}`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },
    getEvaluationFacetoFaceFilters(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/EvaluationFaceToFace/Filters?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })
    },
    getEvaluationFacetoFaceTests(params, idCourse) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/EvaluationFaceToFace/${idCourse}/Tests?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })
    },
    getEvaluationFacetoFaceTestsAvailables(params, idCourse, idTraining) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/EvaluationFaceToFace/${idCourse}/${idTraining}/TestsAvailable?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })
    },
    getAsignedEmployeeEvaluationFaceToFace(data) {
        const url = `${host}api/EvaluationFaceToFace/GetEmployeeEvaluationFaceToFace`
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, data })
    },
    postPrintEvaluation(payload) {
        const url = `${host}api/EvaluationFaceToFace/PrintEvaluation`
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, responseType: "blob", data: payload });
    },
    //CommunicationPRogramsKeyUser
    getCommunicationProgramsKeyUserSummaryExport(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/CommunicationProgramsKeyUser/Summary/Export?${queries}`
        return this.makeAuthorizedRequest({
            url, method, responseType: 'arraybuffer'
        });
    },
    getCommunicationProgramsKeyUserSummary(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/CommunicationProgramsKeyUser/Summary?${queries}`
        return this.makeAuthorizedRequest({ url, method, data });
    },
    getCommunicationProgramsKeyUserDetails(data, idCommunicationProgram) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/CommunicationProgramsKeyUser/${idCommunicationProgram}/Details?${queries}`
        return this.makeAuthorizedRequest({ url, method, data });
    },
    getCommunicationProgramsKeyUserGraphics(data) {
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/CommunicationProgramsKeyUser/Graphics?${queries}`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    exportComplianceAdvance(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        //const url = `${host}api/Communications/ComplianceAdvance/Export?${queries}` //Old request
        const url = `${host}api/Communications/ComplianceAdvance/ExportAllLevels?${queries}`
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },
    //OnSiteEvaluations
    getEvaluationFacetoFace(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/EvaluationFaceToFace?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })
    },
    getExportEvaluationFacetoFace(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/EvaluationFaceToFace/ExportToExcel?${queries}`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },
    getEvaluationFacetoFaceFilters(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/EvaluationFaceToFace/Filters?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })
    },
    getEvaluationFacetoFaceTests(params, idCourse) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/EvaluationFaceToFace/${idCourse}/Tests?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })
    },
    getEvaluationFacetoFaceTestsAvailables(params, idCourse, idTraining) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/EvaluationFaceToFace/${idCourse}/${idTraining}/TestsAvailable?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })
    },
    getAsignedEmployeeEvaluationFaceToFace(data) {
        const url = `${host}api/EvaluationFaceToFace/GetEmployeeEvaluationFaceToFace`
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, data })
    },
    postPrintEvaluation(payload) {
        const url = `${host}api/EvaluationFaceToFace/PrintEvaluation`
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, responseType: "blob", data: payload });
    },
    getEvaluationFacetoFacePrinted(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/EvaluationFaceToFace/PrintedEvaluationFaceToFace?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })
    },
    getEvaluationFacetoFacePrintedFilters(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/EvaluationFaceToFace/FiltersPrintedPresentialEvaluation?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })
    },
    getExportEvaluationFacetoFacePrinted(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/EvaluationFaceToFace/PrintedEvaluationFaceToFace/ExportRoExcel?${queries}`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' });
    },
    setEvaluationFacetoFaceCalEstatus(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/EvaluationFaceToFace/UpdateEstatusPrintedPresentialEvaluation?${queries}`
        const method = 'PUT';
        return this.makeAuthorizedRequest({ url, method })
    },
    //CommunicationPRogramsKeyUser
    getCommunicationProgramsKeyUserSummaryExport(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/CommunicationProgramsKeyUser/Summary/Export?${queries}`
        return this.makeAuthorizedRequest({
            url, method, responseType: 'arraybuffer'
        });
    },
    getCommunicationProgramsKeyUserSummary(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/CommunicationProgramsKeyUser/Summary?${queries}`
        return this.makeAuthorizedRequest({ url, method, data });
    },
    getCommunicationProgramsKeyUserDetails(data, idCommunicationProgram) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/CommunicationProgramsKeyUser/${idCommunicationProgram}/Details?${queries}`
        return this.makeAuthorizedRequest({ url, method, data });
    },
    getCommunicationProgramsKeyUserGraphics(data) {
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/CommunicationProgramsKeyUser/Graphics?${queries}`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method });
    },
    //Signatures
    getSignatureContract() {
        const method = "GET";
        const url = `${host}api/Signatory/GetContract`
        return this.makeAuthorizedRequest({ url, method })
    },
    getSignatureEmployeeCategory() {
        const method = "GET";
        const url = `${host}api/Signatory/GetEmployeeCategory`
        return this.makeAuthorizedRequest({ url, method })
    },
    postUpdateSignature(payload) {
        const url = `${host}api/Signatory`
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, data: payload });
    },
    deleteSignature(id) {
        const method = "DELETE";
        const url = `${host}api/Signatory/${id}`
        return this.makeAuthorizedRequest({ url, method })
    },
    getSignatures(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/Signatory/paginate?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })
    },
    getSignatureFilters(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/Signatory/filter?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })

    },
    //Diplomas
    getDiplomaFilters(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/Diploma/Filters?${queries}`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })
    },
    getPrintDiploma(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/Diploma/PrintDiploma?${queries}`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' })
    },
    getSendDiploma() {
        const url = `${host}api/Diploma/SendDiploma`
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method })
    },
    //ReportCommunicationsCompliance
    getEvaluationsProcedure(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/ReportCommunicationsCompliance/EvaluationProcedure?${queries}`;
        return this.makeAuthorizedRequest({ url, method });
    },
    getEvaluationsContracts(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/ReportCommunicationsCompliance/EvaluationContracts?${queries}`;
        return this.makeAuthorizedRequest({ url, method });
    },
    getEvaluationsFilters() {
        const method = 'GET';
        const url = `${host}api/ReportCommunicationsCompliance/Filter`;
        return this.makeAuthorizedRequest({ url, method });
    },
    //Listado de Key User
    getListKUFilters() {
        const method = 'GET';
        const url = `${host}api/CommunicationProgramsKeyUser/ReporteKU/Filters`;
        return this.makeAuthorizedRequest({ url, method });
    },
    getListKeyUsers(data) {
        const method = 'GET';
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/CommunicationProgramsKeyUser/ReporteKU/List?${queries}`;
        return this.makeAuthorizedRequest({ url, method });
    },
    getPrintListUsers(params) {
        const queries = this.makeQueryParams('', params);
        const url = `${host}api/CommunicationProgramsKeyUser/ReportKU/Export?${queries}`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' })
    },
    //KeyUser Catalogo
    postNewKeyUser(data) {
        const url = `${host}api/Employees/KeyUser`
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, data: data });
    },
    getKeyUsersCatalogue(data) {
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Employees/KeyUser?${queries}`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, data })
    },
    deleteKeyUserCatalogue(id) {
        const url = `${host}api/Employees/KeyUser/${id}`;
        const method = 'DELETE';
        return this.makeAuthorizedRequest({ url, method });
    },
    downloadLayoutEmployee(name) {
        const url = `${host}api/Employees/DownloadLayoutEmployee?fileName=${name}`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' })
    },
    validateEmployeeTemplate(IdCourse, data) {
        const url = `${host}api/Employees/ValidateEmployeeTemplate/${IdCourse}`;
        const method = 'POST';
        return this.makeAuthorizedRequest({ url, method, data })
    },
    downloadLayoutKeyUser(data) {
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Employees/KeyUser/ExportToExcel?${queries}`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, responseType: 'arraybuffer' })
    },
    getEmployeesForKeyusers(data){
        const queries = this.makeQueryParams('', data);
        const url = `${host}api/Employees/KeyUserForKeyUser?${queries}`;
        const method = 'GET';
        return this.makeAuthorizedRequest({ url, method, data })
    }

};
